export default "__VITE_ASSET__b5f7a254__"